"use client";

import * as React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { DayPicker } from "react-day-picker";
import { cn } from "@repo/shared/utils";
import { Button } from "./Button";

export type CalendarProps = React.ComponentProps<typeof DayPicker>;

function Calendar({
  className,
  classNames,
  showOutsideDays = true,
  ...props
}: CalendarProps) {
  return (
    <DayPicker
      showOutsideDays={showOutsideDays}
      className={cn("p-3 h-[350px]", className)}
      classNames={{
        ...classNames,
        months: cn("flex flex-col relative", classNames?.months),
        // month: cn("space-y-4", classNames?.month),
        month_caption: cn(
          "flex justify-center pt-1 items-center",
          classNames?.month_caption
        ),
        // caption_label: cn("text-sm font-medium", classNames?.caption_label),
        // nav: cn("space-x-1 flex items-center", classNames?.nav),
        // nav_button: cn(
        //   Button.variants({ variant: "outline" }),
        //   "h-7 w-7 bg-transparent p-0 opacity-50 hover:opacity-100",
        //   classNames?.nav_button
        // ),
        button_previous: cn(
          Button.variants({ variant: "outline" }),
          "h-7 w-7 bg-transparent p-0 opacity-50 hover:opacity-100 absolute left-1",
          classNames?.button_previous
        ),
        button_next: cn(
          Button.variants({ variant: "outline" }),
          "h-7 w-7 bg-transparent p-0 opacity-50 hover:opacity-100 absolute right-1",
          classNames?.button_next
        ),
        month_grid: cn("w-full border-collapse mt-4", classNames?.month_grid),
        // head_row: cn("flex", classNames?.head_row),
        weekdays: cn("flex flex-row ", classNames?.weekdays),
        weekday: cn(
          "text-muted-foreground rounded-md w-9 font-normal text-[0.8rem]",
          classNames?.weekday
        ),
        week: cn("flex flex-row w-full pt-2", classNames?.week),
        // cell: cn(
        //   "h-9 w-9 text-center text-sm p-0 relative " +
        //     "[&:has([aria-selected].day-range-end)]:rounded-r-md " +
        //     "[&:has([aria-selected].day-outside)]:bg-accent/50 " +
        //     "[&:has([aria-selected])]:bg-accent " +
        //     "first:[&:has([aria-selected])]:rounded-l-md " +
        //     "last:[&:has([aria-selected])]:rounded-r-md " +
        //     "focus-within:relative focus-within:z-20",
        //   classNames?.cell
        // ),
        day: cn(
          Button.variants({ variant: "ghost" }),
          "w-9 h-9 p-0 font-normal aria-selected:opacity-100",
          classNames?.day
        ),
        day_button: cn("w-9 h-9", classNames?.day_button),
        // day_range_end: cn("day-range-end", classNames?.day_range_end),
        selected: cn(
          "bg-primary text-primary-foreground hover:bg-primary hover:text-primary-foreground focus:bg-primary focus:text-primary-foreground",
          classNames?.selected
        ),
        today: cn("bg-accent text-accent-foreground", classNames?.today),
        outside: cn(
          "day-outside text-muted-foreground opacity-50 aria-selected:opacity-50",
          classNames?.outside
        ),
        disabled: cn("text-muted-foreground opacity-50", classNames?.disabled),
        // day_range_middle: cn(
        //   "aria-selected:bg-accent aria-selected:text-accent-foreground",
        //   classNames?.day_range_middle
        // ),
        // day_hidden: cn("invisible", classNames?.day_hidden),
      }}
      components={{
        PreviousMonthButton: ({ ...props }) => (
          <button {...props}>
            <ChevronLeft className="w-4 h-4" />
          </button>
        ),
        NextMonthButton: ({ ...props }) => (
          <button {...props}>
            <ChevronRight className="w-4 h-4" />
          </button>
        ),
      }}
      {...props}
    />
  );
}
Calendar.displayName = "Calendar";

export { Calendar };
